import { Button } from 'components/common/button/Button';

interface InvitationLocationContentProps {
    locationGranted: boolean;
    onAllowLocation: () => void;
    onSkip: () => void;
}

export const InvitationLocationContent = ({
    locationGranted,
    onAllowLocation,
    onSkip
}: InvitationLocationContentProps) => {
    return (
        <>
            {/* Progress Indicator */}
            <div className="location-progress">
                <div className="progress-step completed">1</div>
                <div className="progress-line active"></div>
                <div className="progress-step active">2</div>
                <div className="progress-line"></div>
                <div className="progress-step">3</div>
            </div>

            <div className="progress-labels">
                <span className="progress-label completed">기본 정보</span>
                <span className="progress-label active">위치 권한</span>
                <span className="progress-label">완료</span>
            </div>

            {/* Illustration */}
            <div className="location-illustration">
                <div className="illustration-circle">
                    <div className="location-icon">📍</div>
                </div>
            </div>

            {/* Title Section */}
            <div className="location-title-section">
                <h1 className="location-title">위치 권한을 허용해 주세요</h1>
                <p className="location-subtitle">
                    모임 장소까지의 거리와<br />
                    실시간 위치를 공유할 수 있어요
                </p>
            </div>

            {/* Benefits List */}
            <div className="benefits-list">
                <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <div className="benefit-text">
                        <div className="benefit-title">실시간 위치 공유</div>
                        <div className="benefit-description">
                            모임 장소까지 이동하는 동안 다른 참여자들과 위치를 공유해요
                        </div>
                    </div>
                </div>

                <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <div className="benefit-text">
                        <div className="benefit-title">도착 시간 예측</div>
                        <div className="benefit-description">
                            현재 위치를 기반으로 예상 도착 시간을 자동으로 계산해요
                        </div>
                    </div>
                </div>

                <div className="benefit-item">
                    <div className="benefit-icon">✓</div>
                    <div className="benefit-text">
                        <div className="benefit-title">길찾기 지원</div>
                        <div className="benefit-description">
                            모임 장소까지 최적의 경로를 안내해 드려요
                        </div>
                    </div>
                </div>
            </div>

            {/* Privacy Notice */}
            <div className="location-privacy">
                <div className="privacy-icon">🔒</div>
                <div className="privacy-text">
                    위치 정보는 모임 기간 동안만 사용되며,<br />
                    언제든지 권한을 해제할 수 있어요
                </div>
            </div>

            {/* Action Buttons */}
            <div className="invitation-location-footer">
                <Button
                    text={locationGranted ? "권한이 허용되었어요 ✓" : "위치 권한 허용"}
                    onPress={onAllowLocation}
                    disabled={locationGranted}
                />
                <button className="skip-button" onClick={onSkip}>
                    나중에 할게요
                </button>
            </div>
        </>
    );
};
